export const PayRoutes = [
  // 投保成功页
  {
    path: '/buy-product-success',
    name: 'BuySuccess',
    component: () =>
      import(
        '@/views/Pay/BuySuccess' /* webpackChunkName: "jincheng-yibao-BuySuccess" */
      ),
    meta: {
      title: '投保成功'
    }
  },
  // 投保成功补录信息预留也后期可能去掉
  {
    path: '/insuresuccess-success',
    name: 'BuySuccess',
    component: () =>
      import(
        '@/views/Pay/insuresuccess' /* webpackChunkName: "jincheng-yibao-BuySuccess" */
      ),
    meta: {
      title: '参保成功'
    }
  },
  {
    path: '/waitPayResult/:orderSn',
    name: 'waitPayResult',
    component: () =>
      import(
        '@/views/Pay/waitPayResult' /* webpackChunkName: "jincheng-yibao-BuySuccess" */
      ),
    meta: {
      title: '支付结果等待页'
    }
  }
]
